import { z } from 'zod';
import { LABELS } from '../../constants';
import { requiredFieldError, requiredString, validateMobileAndPhone, validateStringLength } from '../../helper';
import { EmploymentType, PensionType } from '../../types';

export const employedDetails = z.object({
  employerBusinessName: requiredString().and(validateStringLength(LABELS.EMPLOYER_NAME, 255)),
  employerPhoneNumber: validateMobileAndPhone,
  jobTitle: requiredString().and(validateStringLength(LABELS.JOB_TITLE, 255)),
});

export const selfEmployedDetails = z.object({
  abn: requiredString().and(z.string().length(11, { message: 'Please enter a valid ABN' })),
  entityName: requiredString(),
  isSameMobileNumber: z.boolean().default(false),
  phone: validateMobileAndPhone,
});

export const pensionerDetails = z.object({
  pensionType: z.nativeEnum(PensionType, {
    errorMap: () => ({
      message: requiredFieldError(),
    }),
  }),
});

export const otherDetails = z.object({
  name: z.string(),
});

export const baseEmployment = z.object({
  type: z.enum([EmploymentType.EMPLOYED, EmploymentType.SELF_EMPLOYED, EmploymentType.PENSIONER], {
    errorMap: () => ({
      message: requiredFieldError(),
    }),
  }),
  employed: employedDetails.optional(),
  selfEmployed: selfEmployedDetails.optional(),
  pensioner: pensionerDetails.optional(),
});
